var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvancedAnalitics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.875C14.4282 2.875 14.8193 3.11808 15.0088 3.50205L17.8373 9.23227L24.1627 10.1568C24.5864 10.2187 24.9381 10.5158 25.0702 10.923C25.2022 11.3303 25.0917 11.7772 24.785 12.0759L20.2089 16.533L21.2888 22.8298C21.3612 23.2519 21.1877 23.6785 20.8412 23.9302C20.4948 24.1819 20.0354 24.215 19.6564 24.0157L14 21.0411L8.34367 24.0157C7.96463 24.215 7.50531 24.1819 7.15883 23.9302C6.81236 23.6785 6.63883 23.2519 6.71122 22.8298L7.79119 16.533L3.21508 12.0759C2.90839 11.7772 2.79783 11.3303 2.92988 10.923C3.06193 10.5158 3.4137 10.2187 3.83733 10.1568L10.1627 9.23227L12.9912 3.50205C13.1808 3.11808 13.5718 2.875 14 2.875ZM14 6.54166L11.9188 10.758C11.7551 11.0897 11.4388 11.3197 11.0727 11.3732L6.417 12.0537L9.78498 15.3341C10.0503 15.5926 10.1715 15.9651 10.1088 16.3302L9.31424 20.9631L13.4764 18.7743C13.8042 18.6019 14.1959 18.6019 14.5237 18.7743L18.6858 20.9631L17.8912 16.3302C17.8286 15.9651 17.9497 15.5926 18.2151 15.3341L21.5831 12.0537L16.9273 11.3732C16.5613 11.3197 16.245 11.0897 16.0812 10.758L14 6.54166Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedAnalitics);
export default __webpack_public_path__ + "static/media/advanced-analitics.e70dd6875bee2c0b4e5efb36b87d955e.svg";
export { ForwardRef as ReactComponent };